"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const ProductImage_1 = __importDefault(require("../ProductImage"));
const datalayer_1 = require("../../utils/datalayer");
const ardad_1 = require("../../utils/ardad");
const Gallery_module_scss_1 = __importDefault(require("./Gallery.module.scss"));
const MobileGallery = ({ images, thumbnails, selectionDeps, IMGIX_URL, productCode }) => {
    var _a;
    const [selectedImageId, setSelectedImageId] = (0, react_1.useState)((_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.id);
    const switchImage = (imageId) => {
        setSelectedImageId(imageId);
    };
    const mobileContainerClasses = (0, classnames_1.default)(Gallery_module_scss_1.default.mobileContainer, 'u-hidden--lg-up');
    const selectedImageProps = images.find(image => image.id === selectedImageId);
    return (0, jsx_runtime_1.jsxs)("div", { className: mobileContainerClasses, children: [(0, jsx_runtime_1.jsx)(ProductImage_1.default, { productCode: productCode, selectionDeps: selectionDeps, IMGIX_URL: IMGIX_URL, imageClasses: Gallery_module_scss_1.default.featuredImage, containerClasses: Gallery_module_scss_1.default.imageContainerMobile, ...selectedImageProps }), (0, jsx_runtime_1.jsx)("div", { className: Gallery_module_scss_1.default.sliderContainer, children: thumbnails.map((thumbnail, i) => {
                    const itemClasses = (0, classnames_1.default)(Gallery_module_scss_1.default.sliderItem, {
                        [`${Gallery_module_scss_1.default[`sliderItem-isActive`]}`]: thumbnail.id === selectedImageId
                    });
                    return (0, jsx_runtime_1.jsx)("div", { className: itemClasses, onClick: () => {
                            switchImage(thumbnail.id);
                        }, children: (0, jsx_runtime_1.jsx)(ProductImage_1.default, { ...thumbnail, tag: '', imageClasses: Gallery_module_scss_1.default.sliderImage, containerClasses: Gallery_module_scss_1.default.sliderImageContainer, productCode: productCode, selectionDeps: selectionDeps, IMGIX_URL: IMGIX_URL, dataSelector: `gallery-thumbnail-${i}` }) }, thumbnail.id);
                }) })] });
};
const Gallery = ({ IMGIX_URL, productCode, selectionDeps, productTag, galleryAssetDescriptors, altTag }) => {
    const { useProductState } = selectionDeps;
    const productState = useProductState(productCode, []);
    const desktopGalleryRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const thresholds = [50, 75];
        const desktopGallery = desktopGalleryRef.current;
        const pushDataLayerOnScroll = () => {
            const scrollPercentage = (desktopGallery.scrollTop / (desktopGallery.scrollHeight - desktopGallery.clientHeight)) * 100;
            if (scrollPercentage >= thresholds[0]) {
                (0, datalayer_1.pushDataLayerEvent)({
                    'event': 'galleryScroll',
                    'scrollThreshold': thresholds[0]
                });
                thresholds.shift();
            }
        };
        if (desktopGalleryRef) {
            desktopGallery.addEventListener('scroll', pushDataLayerOnScroll);
            return () => {
                desktopGallery.removeEventListener('scroll', pushDataLayerOnScroll);
            };
        }
    }, []);
    const desktopContainer = (0, classnames_1.default)(Gallery_module_scss_1.default.desktopContainer, 'u-hidden--lg-down');
    const images = (0, ardad_1.getArdadImages)(productState, galleryAssetDescriptors, '3-2', altTag, productTag);
    const thumbnails = (0, ardad_1.getArdadImages)(productState, galleryAssetDescriptors, '1-1', altTag);
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: desktopContainer, ref: desktopGalleryRef, children: images.map(image => ((0, jsx_runtime_1.jsx)(ProductImage_1.default, { productCode: productCode, selectionDeps: selectionDeps, IMGIX_URL: IMGIX_URL, imageClasses: Gallery_module_scss_1.default.featuredImage, containerClasses: Gallery_module_scss_1.default.imageContainerDesktop, ...image }, image.id))) }), (0, jsx_runtime_1.jsx)(MobileGallery, { productCode: productCode, selectionDeps: selectionDeps, IMGIX_URL: IMGIX_URL, images: images, thumbnails: thumbnails })] });
};
Gallery.propTypes = {
    productCode: prop_types_1.default.string.isRequired,
    selectionDeps: prop_types_1.default.object.isRequired,
    IMGIX_URL: prop_types_1.default.string.isRequired,
    galleryAssetDescriptors: prop_types_1.default.array.isRequired,
    productTag: prop_types_1.default.string,
    altTag: prop_types_1.default.string
};
exports.default = Gallery;
//# sourceMappingURL=Gallery.js.map